import { useMemo } from 'react';
import { CSV_TABLES_V1 } from 'business/constants';
import { getClientBind } from 'store/APIClient';
import { isKeyOf } from 'helpers/types/utils';

export const useIsV1Table = (selectedTable: string | null): boolean => {
    const bind = getClientBind();
    return useMemo(
        () =>
            isKeyOf(CSV_TABLES_V1, bind) &&
            !!selectedTable &&
            (CSV_TABLES_V1[bind] as readonly string[]).includes(selectedTable),
        [bind, selectedTable],
    );
};
